import React from "react";
import Select from 'react-select';

export default function ObjectMultiSelect({ value, options=undefined, onChange=(e) => {}, placement = "bottom" }){

    const buildValues = (v) => {
        let valArray = [];

        if(Array.isArray(v)){
            return v.map( value => options.find( d => d.value === value ) );
        }

        if(typeof v === 'string'){
            v.split(',').forEach(element => {
                let vTmp = options.find(d => d.value === element);
                if(vTmp){
                    valArray.push(vTmp);
                }
            });
        }        
        return valArray;
    }

    return(
        <Select
            onChange={(e) => {
                const newValues = e.map( item => item.value );
                onChange(newValues.filter((value, index) => newValues.indexOf(value) === index));
            }}
            styles={{
                singleValue: (styles) => ({ ...styles, color:'#000' }),
                input: (styles) => ({ ...styles, color: '#000' }), 
                control: (styles) => ({ ...styles, backgroundColor: '#eee', color: '#000', fontSize: '0.8125em', border: '1px solid #aaa', borderRadius: '10px', width: '100%', padding: '0px 5px', cursor: 'pointer', boxShadow: 'none', ":hover": { ...styles[":hover"], border: '1px solid #7DF04B' } }),
                option: (styles) => ({ ...styles, backgroundColor: '#eee', color: '#000', fontSize: '0.8125em', fontWeight: 'bold', ":hover": { ...styles[":hover"], cursor: 'pointer' } }),
                menu: (styles) => ({ ...styles, backgroundColor: '#eee', borderRight: '2px solid #7DF04B', borderLeft: '2px solid #7DF04B', borderBottom: '2px solid #7DF04B', marginTop: '0px', maxHeight: '250px' }), 
                
            }}
            isMulti
            options={options}
            value={options !== undefined ? buildValues(value) : []}
            defaultValue={options !== undefined ? buildValues(value) : []}
            menuPlacement={ placement }
        />
    );
}